import { FC, ReactElement } from 'react';
import { FormGroup, Label, Input, InputProps } from 'reactstrap';
import React from 'react';
import FormFieldPreviewer from '../helpers/FormFieldPreviewer';

type RadioProps = Omit<InputProps, 'type'> & {
  error?: string | null;
  className?: string;
  name?: string;
  checked: boolean;
  label?: string | ReactElement;
  invisible?: boolean;
  disabled?: boolean;
  type?: 'green' | 'primary' | 'red';
  dataCy?: string;
  viewOnly?: boolean;
};

const Radio: FC<RadioProps> = ({
  error,
  className,
  name,
  checked,
  onChange,
  label,
  disabled,
  type,
  invisible,
  dataCy,
  viewOnly
}) => {
  if (viewOnly)
    return (
      <FormFieldPreviewer
        className={`flex-row-reverse align-items-center ${className}`}
        label={label}
        value={checked}
        type="boolean"
      />
    );

  return (
    <FormGroup
      className={`form-group justify-content-center ${
        invisible ? 'invisible-input' : ''
      } input-wrapper${error ? ' has-error' : ''}${className ? ` ${className}` : ''}`}
      noMargin
    >
      {invisible && error ? <div className="input-error-icon"></div> : ''}
      <FormGroup
        className={`form-radio ${type ? `form-radio__${type}` : ''}`}
        check
        data-cy={dataCy}
      >
        <Label check>
          <Input
            name={name}
            type="radio"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className={checked ? 'checked' : ''}
          />
          {typeof label === 'string' || React.isValidElement(label) ? label : null}
          <span className="checkmark" />
        </Label>
      </FormGroup>
    </FormGroup>
  );
};

export default Radio;
